var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"breadcrumb",on:{"click":_vm.backButton}},[_c('img',{attrs:{"src":require("../../assets/icons/arrow-left-12.svg")}}),_vm._v(" Back ")])
}
var staticRenderFns = []

export { render, staticRenderFns }